import React from 'react'

import { cn } from '@/lib/utils'

const Skeleton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'animate-pulse rounded-xl bg-muted-foreground/40',
        className,
      )}
      {...props}
    />
  )
})

Skeleton.displayName = 'Skeleton'

export { Skeleton }
